export interface IColumnChoice {
  value: string;
  text: string;
}

export interface IColumnColorization {
  pattern?: string;
  color: string;
}

export interface IColumnDescription {
  id: number;
  name: string;
  alias: string;
  description: string;
  type: "Text" | "Date" | "Number" | "Html" | "Checkbox" | "Numeric" | "Currency" | "Percent" | "Duration" | "Email" | "Phone" | "URL" | "User" | "Attachment";
  kind: "Updatable" | "Formula" | "Summary" | "Lookup" | "RecordOwner" | "DateCreated" | "DateModified";
  dataOptions?: string;
  displayOptions?: string;
  width?: number;
  hasDefault?: boolean;
  readOnly: boolean;
  choices?: IColumnChoice[];
  colorization?: IColumnColorization[];
  format?: string;
}

export interface ITableDescription {
  hideNew: boolean;
  hideEdit: boolean;
  hideExport: boolean;
  allowAdd: boolean;
  key: string;
  nameColumn: string;
  columns: IColumnDescription[];
}

// Columns that should not be available for editing
export const BLACKLISTED_COLUMN_NAMES = [
  "Document 1",
  "Document 2",
  "Document 3",
  "Document 4",
  "Document 5",
  "Attachment",
  "Attachments",
  "Files",
  "Images",
  "Id",
  "Record Id",
  "@row.id",
  "Date Created",
  "Date Modified",
  "Created By",
  "Modified By",
  "Record Owner"
];

// Column kinds that cannot be edited
export const NON_EDITABLE_KINDS: IColumnDescription["kind"][] = [
  "Formula",
  "Summary",
  "Lookup",
  "RecordOwner",
  "DateCreated",
  "DateModified"
];

// Helper function to check if a column can be edited
export function isEditableColumn(column: IColumnDescription): boolean {
  if (column.readOnly) return false;
  if (NON_EDITABLE_KINDS.includes(column.kind)) return false;
  if (BLACKLISTED_COLUMN_NAMES.some(name => column.name.toLowerCase().includes(name.toLowerCase()))) return false;
  return true;
}